import React, { useEffect, useState } from 'react';

import { MapTo, Utils } from '@adobe/aem-react-editable-components';
import { useCurrentExperts } from 'hooks/UseCurrentExperts';

import { useInstallerBranchStatus } from 'components/DebFormComponents/Table/useInstallerBranchStatus';
import { filterExpertForTable } from 'components/DebFormComponents/Table/utils';
import { LoadingIndicator } from 'components/LoadingIndicator/LoadingIndicator';
import { PageTitle } from 'components/PageTitle/PageTitle';
import { RenderAemComponent } from 'components/RenderAemComponent/RenderAemComponent';
import { SubAccountsTable } from 'components/SubAccounts/SubAccountsTable';

import { canCreateAccount } from 'utils/DataUtils';

import './SubAccounts.sass';

export const SubAccountPage = (props) => {
  const isEditor = Utils.isInEditor();
  const {
    experts,
    isLoading: isExpertsLoading,
    refetchExperts,
  } = useCurrentExperts({ skip: isEditor });
  const { installer, hasEnergy, hasGas } = useInstallerBranchStatus({ skipInstaller: isEditor });

  const [data, setData] = useState([]);

  useEffect(() => {
    if (!experts || !installer) {
      return;
    }
    const expertsBuild = experts
      .filter((expert) => filterExpertForTable(expert, hasEnergy, hasGas))
      .map((expert) => ({
        id: expert.id,
        completeName: `${expert.vorname} ${expert.nachname}`,
        netzportalEmail: expert.netzportalEmail,
        salesForceStatus: expert.salesForceStatus,
        statusAccountCreation: canCreateAccount({ ...expert, statusEnergy: expert.statusStrom }),
      }));
    setData(expertsBuild);
  }, [experts, installer]);

  if (isEditor) {
    return <RenderAemComponent componentProps={props} name="SubAccountPage" />;
  }

  if (isExpertsLoading) return <LoadingIndicator />;

  return (
    <div>
      <PageTitle text="Zusatzkonten" />
      <br />
      <div>
        Hier können Sie Ihre vergebenen Zusatzkonten einsehen und verwalten.
        <br />
        <br />
        Mit dem erstellten Zugang haben Sie Zugriff auf das mein.Auftragsportal und auf das e-fix.
        Sie können damit auch die Portale der Partnerunternehmen verwenden. Der
        Informationsaustausch aus dem mein.Auftragsportal heraus wird weiterhin über Ihre Firmen
        E-Mail Adresse erfolgen. Mit dem Einzelzugang sehen Sie alle angelegten Aufträge, auch die
        weiterer Fachkräfte, und können diese bearbeiten.
      </div>
      <br />
      <SubAccountsTable data={data} experts={experts} fetchExperts={refetchExperts} />
    </div>
  );
};
MapTo(['e-fix/components/content/zusatzkonten'])(SubAccountPage);
